import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Accordion, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { LinkBtn, Icon, ComponentDataTable } from '../../components';
import { showDncRequest } from '../../requests/dncs';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { basicDnc } from './dnc';
import columns from './columns';
import '../Shared/Employee/Style.scss';
import '../Shared/Company/style.scss';
import './style.scss';

const DncShow = ({ match, withBackButton = true }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [dnc, setDnc] = useState(basicDnc);
  const [activeGeneral, setActiveGeneral] = useState(true);
  const [activeTrainings, setActiveTrainings] = useState(true);
  const dispatch = useDispatch();
  const isProfile = match.path.includes('profile');
  const returnTo = isProfile ? '/profile/dnc' : '/dnc';

  const handleShowRequest = () => {
    setOnRequest(true);
    showDncRequest(match.params.id, {
      dispatch,
      successCallback: response => setDnc(camelCaseEmptyStringRecursive(response.data)),
      callback: () => setOnRequest(false)
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(handleShowRequest, []);

  const trainings = dnc.employeeDncs || dnc.employeeDncsAttributes || [];

  return (
    <div className={`${onRequest && 'bg-opacity'} mx-1 mx-md-3 dnc-show-container`}>
      {onRequest && (
        <div className="containerSpinnerLoad fix-middle center-spinner position-fixed">
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Row className="m-top mb-5">
        {withBackButton && (
          <LinkBtn variant="circle-dark" className="btn-circle" to={returnTo}>
            <Icon icon="chevron-back" />
          </LinkBtn>
        )}
        <Col>
          <h2 className="text-uppercase mt-1">{dnc.name}</h2>
        </Col>
      </Row>

      <div className="yellow-wrapper">
        <Accordion defaultActiveKey="general" className="mb-3">
          <Col className={`${activeGeneral ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
            <Accordion.Toggle
              as={Col}
              eventKey="general"
              className="card-header-title pl-0"
              onClick={() => setActiveGeneral(!activeGeneral)}
              style={{ cursor: 'pointer' }}
            >
              <span>Datos Generales</span>
            </Accordion.Toggle>
          </Col>

          <Accordion.Collapse eventKey="general">
            <Card>
              <Card.Body>
                <Row className="py-2">
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Año:</span>
                      <span className={`answer ${!dnc.year ? 'text-grey' : ''}`}>{dnc.year || 'No Aplica'}</span>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Periodo:</span>
                      <span className={`answer ${!dnc.translatedPeriod ? 'text-grey' : ''}`}>
                        {dnc.translatedPeriod || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex flex-column mb-3">
                      <span className="type">Trabajador:</span>
                      <span className={`answer ${!(dnc.employee?.label || dnc.employee?.fullName) ? 'text-grey' : ''}`}>
                        {dnc.employee?.label || dnc.employee?.fullName || dnc.employee?.full_name || 'No Aplica'}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Accordion.Collapse>
        </Accordion>

        <Accordion defaultActiveKey="trainings" className="mb-3">
          <Col className={`${activeTrainings ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
            <Accordion.Toggle
              as={Col}
              eventKey="trainings"
              className="card-header-title pl-0"
              onClick={() => setActiveTrainings(!activeTrainings)}
              style={{ cursor: 'pointer' }}
            >
              <span>Capacitaciones Requeridas</span>
            </Accordion.Toggle>
          </Col>

          <Accordion.Collapse eventKey="trainings">
            <Card>
              <Card.Body>
                <div className="data-table-yellow">
                  <ComponentDataTable
                    columns={columns()}
                    data={trainings}
                    onRequest={onRequest}
                    totalRows={trainings.length}
                    sortServer={false}
                    paginationServer={false}
                    pagination
                    noHeader
                  />
                </div>
              </Card.Body>
            </Card>
          </Accordion.Collapse>
        </Accordion>
      </div>
    </div>
  );
};

export default DncShow;
